import { render, staticRenderFns } from "./APIHomepage_more_detail.vue?vue&type=template&id=6ff4a209&scoped=true&"
import script from "./APIHomepage_more_detail.vue?vue&type=script&lang=js&"
export * from "./APIHomepage_more_detail.vue?vue&type=script&lang=js&"
import style0 from "./APIHomepage_more_detail.vue?vue&type=style&index=0&id=6ff4a209&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4a209",
  null
  
)

export default component.exports